import React from 'react'
import { connect } from 'react-redux';
import { formatarReal } from '../../util/numberUtil';
import DetalheEncomenda from './DetalheEncomenda';
import alterarExibicaoEncomenda from '../../actions/encomenda/alterarExibicaoEncomenda';
import AcoesEncomenda from './AcoesEncomenda';
import ReactTooltip from 'react-tooltip';
import { mapSituacaoTransmissaoCteOs, situacaoTransmissaoCteOs } from '../../util/constantsUtil';

export class Encomenda extends React.Component {
  exibirIcone () {
    if (this.props.encomenda.exibirDetalhe) {
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoEncomenda(this.props.encomenda)}>
        &#xE5C7;</i>
    }
    return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoEncomenda(this.props.encomenda)}>&#xE5C5;</i>
  }

  exibirIconeMotivoErro (historico) {
    if (historico != null
            && historico.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro) {

        const motivo = historico.motivo ? historico.motivo.replace(/Rejeição: /, '') : ''

        return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`cte-os-${historico.id}-${this.props.encomenda.id}`}>
                    <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                    <ReactTooltip className="tooltip-ut" id={`cte-os-${historico.id}-${this.props.encomenda.id}`}
                                type="dark" effect="solid">
                    <div className="row">{motivo}</div>
                    </ReactTooltip>
                </div>
                </span>
    }

    return ''
  }

  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row align-items-center">
            <div className="col" style={{ cursor: 'pointer' }}>
              {this.exibirIcone()}
            </div>
            <div className="col">
              <span className="titulo-mobile">N° Pedido&nbsp;</span>{this.props.encomenda.idPedido}
            </div>
            <div className="col">
              <span className="titulo-mobile">Vendedor:&nbsp;</span>{this.props.encomenda.nomeVendedor}
            </div>
            <div className="col">
              <span className="titulo-mobile">Descrição:&nbsp;</span>{this.props.encomenda.descricaoProduto}
            </div>
            <div className="col">
              <span className="titulo-mobile">Nome Remetente&nbsp;</span>{this.props.encomenda.remetente.nome}
            </div>
            <div className="col">
              {this.props.encomenda.ultimoHistoricoEmissaoCte == null ? 'Não transmitido' : <>
                <span className="titulo-mobile">Situação Ct-e&nbsp;</span>
                <span style={{color: mapSituacaoTransmissaoCteOs.get(this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave).textColor}}>{this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.valor}</span>
              </>}
              {this.exibirIconeMotivoErro(this.props.encomenda.ultimoHistoricoEmissaoCte)}
            </div>
            <div className="col">
              {this.props.encomenda.ultimoHistoricoEventoCte == null ? '-': <>
                <span className="titulo-mobile">Status evento Ct-e&nbsp;</span>
                <span style={{color: mapSituacaoTransmissaoCteOs.get(this.props.encomenda.ultimoHistoricoEventoCte.situacaotransmissao.chave).textColor}}>{this.props.encomenda.ultimoHistoricoEventoCte.situacaotransmissao.valor}</span>
              </>}
              {this.exibirIconeMotivoErro(this.props.encomenda.ultimoHistoricoEventoCte)}
            </div>
            <div className="col">
              <span className="titulo-mobile">Data da venda:&nbsp;</span>{this.props.encomenda.dataCriacao}
            </div>
            <div className="col">
              <span className="titulo-mobile">Situação:&nbsp;</span>{this.props.encomenda.ultimoHistorico.descricaoSituacao}
            </div>
            <div className="col">
              <span className="titulo-mobile">Valor:&nbsp;</span>{formatarReal(this.props.encomenda.valorTotal)}
            </div>
            <div className="col">
                 <AcoesEncomenda encomenda={this.props.encomenda} selecionarHistoricos={this.props.selecionarHistoricos} preencherModalImagensEncomenda={this.props.preencherModalImagensEncomenda} preencherModalInformarEntregaEncomenda={this.props.preencherModalInformarEntregaEncomenda}/>
            </div>
          </div>
        </div>
        <DetalheEncomenda encomenda={this.props.encomenda}/>
      </div>
    )
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps,
  {
    alterarExibicaoEncomenda
  })(Encomenda)
